import preloadContents from "@xem/entity/classes/preloadContents";
import QRCODE_QUERY from "@xem/link-common/graphql/linkQrQuery.graphql";

export default preloadContents('get.data.qrcode', QRCODE_QUERY, 'no-cache');